import React, { Component } from 'react';
class HolidayList extends Component {
  constructor() {
    super();
    this.state = {
      event_list:'',
    };
  }

componentDidMount(){
    var event_list = [];
    var event_month = this.props.event_month;
    var check_event_is = 0;
    for(var i in event_month){
      var list = event_month[i];
      if(list.length){
        for(var j=0; j<list.length;j++){
          var data = list[j];
          var event_title = data['holiday_title'];
          var holiday_date = this.formatNewDate(data['holiday_date']);
          event_list.push(<p className="ms-4">{event_title+" ("+holiday_date+")"}</p>);
        }
        check_event_is = 1;
      }
    }
    if(check_event_is==0){event_list.push(<p className="ms-4">No Holiday</p>);}
    this.setState({event_list});
}
formatNewDate(date_str){
  var parts = date_str.split('-');
  var day = parts[2];
  var month = parseInt(parts[1]);
  var year = parseInt(parts[0]);
  var monthNames = ["","Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var formattedDate = day+"-"+monthNames[month]+"-"+year;
  return formattedDate;
}


  render() {
    return (
        <>
        <div className="col-md-4">
          <div className="container mt-4">
            <div className="accordion" id="HolidayspryTabs">
              <div className="accordion-item" id="tab-1">
                <h2 className="accordion-header" id="headingOne">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Holiday List
                  </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#HolidayspryTabs">
                  <div className="accordion-body background-white calendar_card">
                    {this.state.event_list}
                  </div>
                </div>
                </div>
                </div>
          </div>
        </div>

        </>
    );
  }
}

export default HolidayList;
